import React, {useReducer} from 'react'
import {serviceListReducer} from "./serviceListReducer";

const ServiceListContext = React.createContext([])

const withServiceListContext = Component => {

    return props => {

        const [state, dispatch] = useReducer(serviceListReducer, [])

        return (
            <ServiceListContext.Provider value={ { state, dispatch } }>
                <Component {...props}/>
            </ServiceListContext.Provider>
        )
    }
}

const ServiceListContextProvider = ({children}) => {

    const [state, dispatch] = useReducer(serviceListReducer, [])

    return (
        <ServiceListContext.Provider value={ { state, dispatch } }>
            {children}
        </ServiceListContext.Provider>
    )
}

export {ServiceListContext, withServiceListContext, ServiceListContextProvider}